<div class="bg-login  w-full h-full relative ">
  <div class="flex md:flex-row flex-col items-center bg-pattern h-full w-full relative ">
    <div class="relative md:w-5/12 w-full bg-white flex flex-col justify-center min-h-full ">
      <div class="md:w-9/12 w-11/12 mx-auto flex flex-col gap-2 max-h-full overflow-auto ">
        <div class="flex items-center justify-between py-2 px-3.5">
          <div class="flex items-center">
            <img src="/assets/images/new-tgsd-logo.svg"
                 alt="Dirisha la Huduma za Serikali"
                 class="h-10 lg:h-20 md:h-20 sm:h-14 cursor-pointer"/>
            <div class=" leading-tight px-2 text-primary-500">
                <span class="block  text-[14px] md:text-[17px] lg:text-[20px]">
                  {{"Tanzania Government" |concat|translate }}
                </span>
              <span class="block  text-[14px] md:text-[17px] lg:text-[20px]">
                 {{" Services Directory" |concat|translate }}
                </span>
            </div>
          </div>

          <button
            class="!bg-white border border-primary-500 flex items-center px-2 py-1 gap-2 rounded-md text-md !text-primary-500"
            matRipple
            routerLink="/home">
            <mat-icon class="!scale-75" svgIcon="home2"></mat-icon>
            <span>{{"Rudi mwanzo" |concat|translate }}</span>
          </button>
        </div>

        <div class="md:text-2xl text-lg text-primary-500 font-semibold text-center my-3"> {{"Karibu Dirisha la Huduma za Serikali" |concat|translate }}
        </div>

        <ng-container
          [ngTemplateOutlet]="dynamicViewContent">
        </ng-container>

      </div>
    </div>
    <div class="md:w-7/12 w-full relative h-full">
      <app-guest-carousel></app-guest-carousel>
    </div>
  </div>
  <app-copy-rights></app-copy-rights>
</div>
